import React, { useEffect, createElement } from 'react';
export const GoogleTagManager = () => {
  useEffect(() => {
    // Create and inject the first script tag (async)
    const scriptAsync = document.createElement('script');
    scriptAsync.async = true;
    scriptAsync.src = 'https://www.googletagmanager.com/gtag/js?id=AW-649210165';
    document.head.appendChild(scriptAsync);
    // Create and inject the second script tag (initialization)
    const scriptInit = document.createElement('script');
    scriptInit.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-649210165');
    `;
    document.head.appendChild(scriptInit);
    // Cleanup function to remove scripts when component unmounts
    return () => {
      document.head.removeChild(scriptAsync);
      document.head.removeChild(scriptInit);
    };
  }, []);
  return null; // This component doesn't render anything visible
};